import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";
import { postTags, updateTags } from "./tags";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  photos: {
    data: [],
  },
  singlePhoto: {},
  fetchLoading: false,
  deleteGalLoading: false,
};

const slice = createSlice({
  name: "photo",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // START LOADING
    startDeleteLoading(state) {
      state.deleteGalLoading = true;
    },

    // START LOADING
    stopDeleteLoading(state) {
      state.deleteGalLoading = false;
    },

    // FETCH  LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.fetchLoading = false;
      state.deleteGalLoading = false;
    },

    // TODO: success post blog

    postPhotoSuccess(state, action) {
      state.isLoading = false;
      // state.photos.data = [action.payload, ...state.photos.data];
      // state.photos.meta.total += 1;
    },
    // TODO: successFetch blog

    getPhotoSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.photos = action.payload;
    },

    // TODO: single blog fetch success

    getSinglePhotoSucess(state, action) {
      state.isLoading = false;
      state.singlePhoto = action.payload;
    },

    // Update blog
    updatePhotoSuccess(state, action) {
      state.isLoading = false;
      // state.photos.data = state.photos.data.map((photo) => {
      //   if (photo.slug === action.payload.slug) {
      //     return action.payload;
      //   } else {
      //     return photo;
      //   }
      // });
    },

    // delete blog
    deletePhotoSuccess(state, action) {
      state.isLoading = false;
      // state.photos.data = state.photos.data.filter(
      //   (photo) => photo.id !== action.payload
      // );
      // state.photos.meta.total -= 1;
    },
  },
});

export default slice.reducer;

export function getPhotos({ categoryId, limit = 5, page = 0, season_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`items`, {
        params: {
          limit,
          page: page + 1,
          category_slug: categoryId,
          season_id,
        },
      });
      dispatch(
        slice.actions.getPhotoSuccess({
          data: response.data.data.data,
          meta: {
            total: response.data.data.total,
          },
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updatePhoto({ slug, data, enqueueSnackbar, tagData, tag_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`items/${slug}`, data);
      dispatch(slice.actions.updatePhotoSuccess(response.data.data));
      if (
        tagData?.team ||
        tagData?.player ||
        tagData?.game ||
        tagData?.category
      ) {
        if (tag_id) {
          dispatch(
            updateTags({
              tagData: { ...tagData, item_id: response.data.data.id },
              enqueueSnackbar,
              tag_id,
            })
          );
        } else {
          dispatch(
            postTags({
              tagData: { ...tagData, item_id: response.data.data.id },
              enqueueSnackbar,
            })
          );
        }
      }
      enqueueSnackbar("Photo is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function postPhotos({ data, enqueueSnackbar, navigate, tagData }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`items`, data);
      dispatch(slice.actions.postPhotoSuccess(response.data.data));
      dispatch(
        postTags({
          tagData: { ...tagData, item_id: response.data.data.id },
          enqueueSnackbar,
        })
      );
      enqueueSnackbar("Photo is created successfully");
      navigate(PATH_DASHBOARD.photo.list);
    } catch (error) {
      enqueueSnackbar(error.message || "error creating photos", {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPhoto(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`items/${id}`);

      dispatch(slice.actions.getSinglePhotoSucess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deletePhoto({
  id,
  enqueueSnackbar,
  categoryId,
  pagination,
  season_id,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`items/${id}`);
      dispatch(slice.actions.deletePhotoSuccess(id));
      dispatch(
        getPhotos({
          categoryId,
          page: pagination.page,
          limit: pagination.limit,
          season_id,
        })
      );
      enqueueSnackbar("Photo is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteSingleGallery({
  item_id,
  gallery_name,
  enqueueSnackbar,
  setGalleries,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startDeleteLoading());
    try {
      await axios.post(`items/${item_id}/${gallery_name}`);
      // dispatch(slice.actions.deletePhotoSuccess(id));
      enqueueSnackbar(`gallery image is deleted successfully`);
      setGalleries((prev) =>
        prev.filter((f, index) => {
          return index !== gallery_name;
        })
      );
      dispatch(slice.actions.stopDeleteLoading());
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}
